var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supsis-table", class: { "zebra-row": _vm.zebraRow } },
    [
      _vm.topPagination
        ? _c(
            "div",
            {
              staticClass: "supsis-table-options",
              class: ["align-" + _vm.headAlign],
            },
            [
              _vm.topPagination
                ? _c("ve-pagination", {
                    staticClass: "custom-pagination",
                    attrs: {
                      total: _vm.cursor.total,
                      "page-index": _vm.cursor.page,
                      "page-size": _vm.cursor.perPage,
                      "page-size-option": _vm.paginationOptions,
                    },
                    on: {
                      "on-page-number-change": _vm.pageNumberChange,
                      "on-page-size-change": _vm.perPageNumberChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSlotHas("header") ? _vm._t("header") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "ve-table",
            _vm._b(
              {
                staticStyle: { "word-break": "break-word" },
                attrs: {
                  columns: _vm.reFormatedColumns,
                  "table-data": _vm.rows,
                },
              },
              "ve-table",
              _vm.params,
              false
            )
          ),
          _vm._v(" "),
          _vm.isSlotHas("emptyData") && _vm.rows.length <= 0
            ? _c(
                "div",
                {
                  staticClass: "supsis-table-empty-data",
                  class: { bordered: _vm.emptyDataBordered },
                },
                [_vm._t("emptyData")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isSlotHas("footer") ? _vm._t("footer") : _vm._e(),
      _vm._v(" "),
      _vm.downloadOptions || _vm.bottomPagination
        ? _c(
            "div",
            {
              staticClass: "supsis-table-options",
              class: ["align-" + _vm.bottomAlign],
            },
            [
              _vm.downloadOptions
                ? _c(
                    "div",
                    { staticClass: "download-options" },
                    [
                      _vm.downloadOptions.downloadTable && _vm.downloadEnabled()
                        ? _c(
                            "SupsisButton",
                            {
                              attrs: { ghost: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("download-table")
                                },
                              },
                            },
                            [
                              _c(
                                "md-icon",
                                {
                                  staticStyle: {
                                    color: "black",
                                    "font-size": "16px !important",
                                  },
                                },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.downloadThePage"))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.downloadOptions.downloadAll && _vm.downloadEnabled()
                        ? _c(
                            "SupsisButton",
                            {
                              attrs: { ghost: "" },
                              on: {
                                click: function ($event) {
                                  _vm.$feature.beforeDownloadExcel(function () {
                                    return _vm.$emit("download-all")
                                  })
                                },
                              },
                            },
                            [
                              _c(
                                "md-icon",
                                {
                                  staticStyle: {
                                    color: "black",
                                    "font-size": "16px !important",
                                  },
                                },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.downloadAllData"))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "2px" } },
                [
                  _vm.tableSettings
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { ghost: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("table-settings")
                            },
                          },
                        },
                        [
                          _c(
                            "md-icon",
                            {
                              staticStyle: {
                                color: "black",
                                "font-size": "16px !important",
                              },
                            },
                            [_vm._v("settings")]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.tableSettings"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bottomPagination && !_vm.tokenBasedPagination
                    ? _c("ve-pagination", {
                        staticClass: "custom-pagination",
                        attrs: {
                          total: _vm.cursor.total,
                          "page-index": _vm.cursor.page,
                          "page-size": _vm.cursor.perPage,
                          "page-size-option": _vm.paginationOptions,
                        },
                        on: {
                          "on-page-number-change": _vm.pageNumberChange,
                          "on-page-size-change": _vm.perPageNumberChange,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bottomPagination && _vm.tokenBasedPagination
                    ? _c("div", { staticClass: "token-based-pagination" }, [
                        _c("div", { staticClass: "pagination-info" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.totalRecords", {
                                  count: _vm.cursor.total || 0,
                                })
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pagination-controls" },
                          [
                            _c(
                              "a-select",
                              {
                                staticStyle: {
                                  width: "80px",
                                  "margin-right": "8px",
                                },
                                attrs: { size: "small" },
                                on: { change: _vm.perPageNumberChange },
                                model: {
                                  value: _vm.cursor.perPage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cursor, "perPage", $$v)
                                  },
                                  expression: "cursor.perPage",
                                },
                              },
                              _vm._l(_vm.paginationOptions, function (option) {
                                return _c(
                                  "a-select-option",
                                  { key: option, attrs: { value: option } },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(option) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  size: "small",
                                  disabled: !_vm.cursor.prevToken,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("cursor-changed", {
                                      action: "prev",
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("chevron_left"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: {
                                  size: "small",
                                  disabled: !_vm.cursor.nextToken,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("cursor-changed", {
                                      action: "next",
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("chevron_right"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }